// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38oro","col":"styles_col__23svj"};